
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Fee Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Fee Details</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
          <!-- Small boxes (Stat box) -->
          <div class="row">
            <div class="col-md-4 col-sm-6 col-12">
              <div class="info-box bg-info">
                <span class="info-box-icon"><i class="far fa-bookmark"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Total Fee</span>
                  <span class="info-box-number">{{feesum.Total}}</span>
  
                  <div class="progress">
                    <div class="progress-bar" style="width: 70%"></div>
                  </div>
                  <span class="progress-description">
                    <!-- 70% Increase in 30 Days -->
                  </span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-4 col-sm-6 col-12">
              <div class="info-box bg-success">
                <span class="info-box-icon"><i class="fa fa-check-square"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Paid</span>
                  <span class="info-box-number">{{feesum.Paid}}</span>
  
                  <div class="progress">
                    <div class="progress-bar" style="width: 70%"></div>
                  </div>
                  <span class="progress-description">
                    <!-- 70% Increase in 30 Days -->
                  </span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
           
            <!-- /.col -->
            <div class="col-md-4 col-sm-6 col-12">
              <div class="info-box bg-danger">
                <span class="info-box-icon"><i class="fas fa-hourglass"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Balance</span>
                  <span class="info-box-number">{{feesum.Balance}}</span>
  
                  <div class="progress">
                    <div class="progress-bar" style="width: 70%"></div>
                  </div>
                  <span class="progress-description">
                    <!-- 70% Increase in 30 Days -->
                  </span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
          </div>
        <div class="row">
          <div class="col-12">
            <div class="card card-outline card-danger">
              <!-- <div class="card-header">
                <h3 class="card-title">Fee Details</h3>
              </div> -->
              <!-- /.card-header -->
              <div class="card-body" >
                <table role="table" class="table table-hover">
                    <thead role="rowgroup">
                      <tr role="row" >
                        <th role="columnheader">#</th>
                      
                        <th role="columnheader">Fee Type</th>
                        <th role="columnheader">Instalments</th>
                        <th role="columnheader">Amount</th>
                        <th role="columnheader">Paid</th>
                        <th role="columnheader">Balance</th>
                    
                        <th role="columnheader"></th>
                        <th role="columnheader"></th>
                     
                      </tr>
                    </thead>
                    <tbody role="rowgroup" *ngFor="let fee of feedtls;let i = index">
                      <tr role="row">
                        <td role="cell">{{i+1}}</td>
                    
                        <td role="cell">{{fee.accatnm}}</td>
                        <td role="cell">{{fee.inscd}}</td>
                        <td role="cell">{{fee.ttlfee}}</td>
                        <td role="cell">{{fee.retamt}}</td>
                        <td role="cell"><span  *ngIf="fee.Balance==0" class="badge bg-success">{{fee.Balance}}</span><span *ngIf="fee.Balance!=0" class="badge bg-danger">{{fee.Balance}}</span></td>
                      
                    
                        <td role="cell">
                            <button type="button" class="btn btn-danger btn-sm" (click)="openpaymdl(mdlpay,fee)"  *ngIf="fee.Balance!=0">
                            <i class="fa fa-money-bill-alt"> </i> Pay</button>
                            <button type="button" class="btn btn-success btn-sm"  *ngIf="fee.Balance<=0">
                              <i class="fa fa-check">  </i>  Paid</button>                           
                        </td>
                        <!-- <th role="columnheader"> <button type="button" class="btn btn-success  btn-sm" *ngIf="fee.Balance==0">  
                          <i class="fa fa-download">  </i> Receipt
                      </button></th> -->
                      <!-- <td role="cell">
                        <ul>
                          <li>
                        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                          <span class="dropdown-item dropdown-header">15 Notifications</span>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item">
                            <i class="fas fa-envelope mr-2"></i> 4 new messages
                            <span class="float-right text-muted text-sm">3 mins</span>
                          </a>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item">
                            <i class="fas fa-users mr-2"></i> 8 friend requests
                            <span class="float-right text-muted text-sm">12 hours</span>
                          </a>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item">
                            <i class="fas fa-file mr-2"></i> 3 new reports
                            <span class="float-right text-muted text-sm">2 days</span>
                          </a>
                          <div class="dropdown-divider"></div>
                          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
                        </div></li></ul>
                      </td> -->
                      <td> <div class="dropdown pdropop">
                        <a href="" data-toggle="dropdown" class="dropdown-toggle" aria-expanded="false"><i class="fa fa-print editicon"></i>  <b class="caret"></b></a>
                        <ul class="dropdown-menu pdropm" style="margin-left: -114px;">
                           <!-- <li><a (click)="printpayack(stu.stuid,stu.recid,stu.vhno)" style="color:#fff;"><i class="fa fa-print"></i> Part-Receipts</a></li> -->
                           <li><a class="dropdown-item" (click)="openmdlpartpays(mdlrecdet,fee,fee.vhno)" style="cursor: pointer" ><i class="fa fa-print"></i> Part-Receipts</a></li>
                            <li *ngIf="fee.Balance==0" ><a class="dropdown-item" style="cursor: pointer" (click)="printpayreceipt(fee.stuid,fee.recid,fee.vhno,fee.inid)"  ><i class="fa fa-print"></i> Receipt</a></li> 
                           
                       
                       </ul>
                                                                   </div></td>
                      </tr>
                   
                   
                    </tbody>
                  </table>


              </div>


             
              <!-- /.col -->
   


              



              <!-- /.card-body -->
            </div>
            <!-- /.card -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title ">
                  <!-- <i class="fas fa-info"></i> -->
                  Terms and Conditions
                </h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <dl *ngFor="let pt of feedmet">
                  <dt>{{pt.pt}}</dt>
                  <dd>{{pt.tf}}</dd>
                  
                </dl>
              </div>
              <!-- /.card-body -->
            </div>
          
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
      <form #form ngNoForm id="nonseamless" method="post" name="redirect"
      action="https://secure.ccavenue.com/transaction.do?command=initiateTransaction">
      <input type="hidden" id="encRequest" name="encRequest" [ngModel]="encRequest">
      <input type="hidden" name="access_code" id="access_code" [ngModel]="accessCode">
  </form>
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->

  <ng-template #mdlrecdet let-modal>
    <form name="fsubalot" (ngSubmit)="fsubalot.form.valid " #fsubalot="ngForm" novalidate >
    <div class="modal-header">
        <span class="modal-title" id="modal-basic-title">Part Payment Details</span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    <div class="modal-body">
        <div class="box-body">
            
              <div class="container-fluid" style="padding-left: 6px;min-height: 60px;">
                
  <div class="row"><div class="col-md-12"><b>Name : </b>{{objvhead.name}} |    <b>Admission No. : </b> {{objvhead.admno}}|    <b>Class : </b>{{objvhead.clcode}}-{{objvhead.seccode}}</div></div>
  <div class="row"><div class="col-md-12"><b>Fees Category : </b>{{objvhead.accatnm}} |     <b>Installment : </b> {{objvhead.insnm}}</div></div>
              
                    
                         <table class="table table-stripped table-hover  ">
                             <thead>
                               
                                 <th>#</th>
                                 <th>Rec No</th>
                                 <th>Rec Date</th>
                                 <th>Amount</th>
                                 <th>MOT</th>
                                 <th style="width:30px ;"></th>
                             </thead>
                             <tbody>
                                 <tr *ngFor="let k of arrfeerech; let i=index">
                                     
  <td>{{i+1}}</td>
  <td>{{k.recno}}</td>
  <td>{{k.recdt}}</td>
  <td>{{k.recamt}}</td>
  <td>{{k.mop}}</td>
  <td><i class="fa fa-print editicon pull-right" tooltip="Print Payment Acknowledgement" (click)="printpayack(objvhead.stuid,k.recid,k.vhno,objvhead.inid)"></i></td>
                                 </tr>
                                 <!-- <tr>
                                   <td colspan="3" style="text-align:right;"> <b>TOTAL : </b></td>
                                   <td ><b>{{ttldfeamt}}</b> </td>
                                   <td></td>
                                 </tr> -->
                             </tbody>
                            
                         </table>
             
                
            </div>
            <div class="modal-footer">
                <!-- <button class="btn btn-success btn-round commandbtn " [disabled]="!fsubalot.form.valid" (click)="save_sp_masclasssubject()" >
                    <i class="fa fa-check" aria-hidden="true" ></i>Save</button> -->
              
            
            
            </div> 
        
        </div>
    </div>
  </form>
  </ng-template>


  <ng-template #mdlpay let-modal>
    <form name="fsubalot" (ngSubmit)="fsubalot.form.valid " #fsubalot="ngForm" novalidate >
    <div class="modal-header">
        <span class="modal-title" id="modal-basic-title">Details</span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    <div class="modal-body">
        <div class="box-body">
            
              <div class="container-fluid" >
                
 
                <div class="row">
                  <div class="col-md-12">
                  
                    <div class="feildsmargin">
                      <label  class="lblh">Name : 
                      </label>
                     <label class="lbld">{{objfeesh.billingname}}</label> 
                     
                    </div> 

                    <div class="feildsmargin">
                      <label  class="lblh">Class : 
                      </label>
                     <label class="lbld">{{objfeesh.stuclass}}</label> 
                     
                    </div> 
                    <div class="feildsmargin">
                        <label  class="lblh">Fees Type : 
                        </label>
                       <label class="lbld">{{objfeesh.feetype}}</label> 
                       
                      </div>
                      
                    
                      <div class="feildsmargin">
                        <label  class="lblh">Amount : 
                        </label>
                       <label class="lbld">{{objfeesh.RecAmt}}</label> 
                       
                      </div>
                     
              
                   
                    </div>
              
                     
                
                      
                    </div> 
                
            </div>
            <div class="modal-footer">
           
              <button type="button" class="btn btn-danger btn-sm" (click)="paymentapi()"  *ngIf="objfeesh.Balance!=0">
                <i class="fa fa-money">  Pay Now</i></button>
            
            
            </div> 
        
        </div>
    </div>
  </form>
  </ng-template>